import { Config } from '@leverege/plugin';
export default {
  isBetaOn() {
    return Config.get('BetaSwitch', 'isBetaSite');
  }
};